<div class="attachment-panel">
  <div class="attachment-panel__header">
    <span>Attachment</span>
    <button
      class="add-file-btn"
      mat-button
      color="primary"
      (click)="$event.stopPropagation(); inputFile.click()"
    >
      <mat-icon>add</mat-icon> <span>Add more</span>
    </button>
    <input
      class="input-file"
      type="file"
      #inputFile
      [multiple]="true"
      portalSigningUpload
      (click)="$event.stopPropagation()"
      [isUploadImmediately]="true"
      [isPublic]="true"
      [maxFiles]="maxCurrentSlot"
      [maxFileSize]="maxFileSize"
      [isReplaced]="true"
      (finishedFile)="onAddPhoto($event)"
      [apiGetUploadLink]="getUploadLink.bind(this)"
      [accept]="allowedMimeTypes"
      [allowedMimeType]="allowedMimeTypes"
      [allowExtensions]="allowExtensions"
      (fullSlot)="comfirmFullSlot()"
    />
  </div>
  <mat-divider *ngIf="uploadSelection.selected.length"></mat-divider>
  <div
    *ngIf="uploadSelection.selected.length"
    class="attachment-panel__body"
  >
    <div
      class="attachment-item"
      *ngFor="let attachment of uploadSelection.selected"
    >
      <div class="attachment-item__cell">
        <div class="attachment-item__icon">
          <mat-icon svgIcon="document"></mat-icon>
        </div>
        <p class="m-0 text-truncate">
          <span class="text-color-dark">{{ attachment.file?.name }}</span>
        </p>
        <span class="text-color-gray">{{ ' (' + (attachment.file?.size | fileSize) + ')' }}</span>
      </div>
      <div class="attachment-item__cell attachment-item__action-cell">
        <button
          mat-icon-button
          (click)="$event.stopPropagation(); onRemovePhoto(attachment)"
        >
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
